/**
 * RemoveGemFromTower use case: remove gem from tower slot to inventory.
 */

import { removeGemFromTower } from "../../domain/session.js";
import type { PlaceGemError } from "../../domain/types.js";
import type { RenderPort, AudioPort } from "../ports.js";
import { sessionToView } from "../state-view.js";

export interface RemoveGemFromTowerDeps {
  render: RenderPort;
  audio: AudioPort;
  getSession(): import("../../domain/session.js").GameSession | null;
}

export function createRemoveGemFromTower(deps: RemoveGemFromTowerDeps) {
  return function removeGemFromTowerUseCase(
    towerId: string,
    slotIndex: number
  ): { ok: true } | PlaceGemError {
    const session = deps.getSession();
    if (!session) return { code: "InvalidSlot" };
    const gem = removeGemFromTower(session, towerId, slotIndex);
    if (!gem) return { code: "InvalidSlot" };
    deps.render.update(sessionToView(session, "game"));
    deps.audio.play("click");
    return { ok: true };
  };
}
